module.exports = __webpack_public_path__ + "static/photo_9-785f7de42697f4c7b3b4e90bac88f9ce.jpg";